import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ContactForm from './components/contactForm';
import ContactList from './components/contactList';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Button,
  Input,
  UncontrolledDropdown,
  Nav,
  NavItem,
  TabContent,
  NavLink
} from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { aPI_Contacts } from '../../../../constants/APIs';
import Pagination from '../../../../containers/pages/Pagination';
// import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import no_profile from '../../../../assets/profile_pic.png';
import IntlMessages from '../../../../helpers/IntlMessages';

const getContact = (props) => {
  if (props?.original?.name && props?.original.name !== null)
    return (
      <p>
        <i className={`iconsminds-user`}></i> <b>{props?.original.name}</b>
      </p>
    );
  else if (props?.original?.email && props?.original.email !== null)
    return (
      <p>
        <i className={`iconsminds-at-sign`}></i> <b>{props?.original.email}</b>
      </p>
    );
  else if (props?.original?.phone && props?.original.phone !== null)
    return (
      <p>
        <i className={`simple-icon-phone`}></i> <b>{props?.original.phone}</b>
      </p>
    );
};

const contactTableColumns = [
  {
    Header: (
      <p>
        <i className="simple-icon-people"></i> Contact
      </p>
    ),
    accessor: 'name',
    Cell: (props) => <p className="ml-3">{getContact(props)}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-calendar`}></i> First Acitivity
      </p>
    ),
    accessor: 'firstActivityDate',
    Cell: (props) => <p className="ml-4">{props?.original?.firstActivity}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-calendar`}></i> Recent Acitivity
      </p>
    ),
    accessor: 'lastActivityDate',
    Cell: (props) => (
      <p className="ml-4">
        {props?.original?.lastActivity === 'Unknown'
          ? props?.original?.firstActivity
          : props?.original?.lastActivity}
      </p>
    ),
  },
  {
    Header: (
      <p>
        {' '}
        <i className="iconsminds-yes"></i>  <IntlMessages id='dashboards.marketingconsent' />
      </p>
    ),
    accessor: 'consent',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-settings`}></i> Last Channel
      </p>
    ),
    accessor: 'lastChannel',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: '',
    Cell: (props) => (
      <Button
        outline
        size="xs"
        color="primary"
        className="ml-4"
        onClick={() =>
        (window.location.href =
          '/app/pages/contact-details/' + props?.original?.contactId)
        }
      >
        <i className={`simple-icon-action-redo`}></i>
        {'  '}
        Open Contact
      </Button>
    ),
  },
];

const contactCompendiumTableColumns = [
  {
    Header: '',
    accessor: 'name',
    Cell: (props) => {
      const baseImage = props?.original.profile;
      console.log('009', baseImage);
      const hasImage = baseImage !== undefined && baseImage !== null && baseImage.trim() !== '';

      return (
        <img
          src={
            hasImage
              ? `data:image/jpeg;base64,${baseImage}`
              : no_profile
          }
          width="25"
          height="25"
          alt="Profile"
        />
      );
    }
  },
  {
    Header: (
      <p>
        <i className={`iconsminds-user`}></i> Name
      </p>
    ),
    accessor: 'name',
    Cell: (props) => <p className="ml-3">{props?.original.name}</p>,
  },
  {
    Header: (
      <p>
        <i className={`iconsminds-at-sign`}></i> Email
      </p>
    ),
    accessor: 'email',
    Cell: (props) => <p className="ml-4">{props?.original.email}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-phone`}></i> Phone Number
      </p>
    ),
    accessor: 'phone',
    Cell: (props) => <p className="ml-4">{props?.original.phone}</p>,
  },
  {
    Header: (
      <p>
        {' '}
        <i className="iconsminds-yes"></i>     <IntlMessages id='dashboards.marketingconsent' />
      </p>
    ),
    accessor: 'consent',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: '',
    Cell: (props) => (
      <Button
        outline
        size="xs"
        color="primary"
        className="ml-4"
        onClick={() =>
        (window.location.href =
          '/app/pages/contact-details/' + props?.original?.contactId)
        }
      >
        <i className={`simple-icon-action-redo`}></i>
        {'  '}
        Open Contact
      </Button>
    ),
  },
];

function Index({ propertyId }) {
  const [channel, setChannel] = useState(
    window.location.href.includes('/app/pages/members') ? 'Compendium' : ''
  );
  const [addContact, setEditContact] = useState(false);
  const [contactList, setContactsList] = useState([]);
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(25);
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [contact, setContact] = useState();

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  const toggle = () => setEditContact(!addContact);

  const onChangePage = (page) => setcurrentPage(page);

  useEffect(() => {
    handleContactLoad();
  }, [propertyId, currentPage, SelectedPageSize, search, channel]);

  const handleContactLoad = () => {
    AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}?groupId=${getGroupID()}&propertyId=${propertyId}&search=${search}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}&type=${channel}`,
    }).then((res) => {
      console.log(res.data);
      const sortedContacts = res.data?.contacts.sort((a, b) =>
        a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())
      );
      setTotalItems(res.data.totalItems);
      setTotalPages(res.data.totalPages);
      setContactsList(sortedContacts);
    });
  };

  const onSearchKey = (e) => {
    //if (e.key === "Enter") {
    setcurrentPage(1);
    setSearch(e.target.value.toLowerCase());
    // LoadBmbData();
    //}
  };

  const handleSave = (body) => {
    if (aPI_Contacts.email !== '') {
      AxiosAPI({
        method: 'POST',
        url: `${aPI_Contacts}`,
        data: body,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        toggle();
        handleContactLoad();
      });
    } else toggle();
  };

  return (
    <Fragment>
      <Row className="mb-3">
        <Colxx xxs="12" className="mb-3">
          <div className="float-md-left">
            <Button color="primary" outline size="xs" onClick={toggle}>
              + Contact
            </Button>
          </div>
          {/* <div className="float-md-left ml-3">
            <UncontrolledDropdown className="d-inline-block">
              <DropdownToggle caret color="outline-primary" size="xs">
                {channel === '' ? 'Website' : 'Compendium'}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem key={'Website'} onClick={() => setChannel('')}>
                  Website
                </DropdownItem>
                <DropdownItem
                  key={'Compendium'}
                  onClick={() => setChannel('Compendium')}
                >
                  Compendium
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div> */}
          <div className="float-md-right">
            <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
            <UncontrolledDropdown className="d-inline-block">
              <DropdownToggle caret color="outline-dark" size="xs">
                {SelectedPageSize}
              </DropdownToggle>
              <DropdownMenu right>
                {pageSizes.map((size, index) => {
                  return (
                    <DropdownItem
                      key={index}
                      onClick={() => changePageSize(size)}
                    >
                      {size}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <div className="float-md-right mr-3">
            <div
              className="search-sm d-inline-block float-md-left mr-3 mb-1 align-top"
              style={{ width: '100%' }}
            >
              <Input
                type="text"
                name="keyword"
                id="search"
                placeholder="Search"
                onKeyPress={(e) => onSearchKey(e)}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </Colxx>
        <Colxx xxs="12" className="mb-1">
          <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
            <NavItem>
              <NavLink
                className={classnames({
                  active: channel === '',
                  'nav-link': true,
                })}
                onClick={() => {
                  setChannel('');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${channel === '' ? 'var(--theme-color-1)' : '#8f8f8f'
                      }`,
                  }}
                >

                  Visitors
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: channel === 'Compendium',
                  'nav-link': true,
                })}
                onClick={() => {
                  setChannel('Compendium');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${channel === 'Compendium' ? 'var(--theme-color-1)' : '#8f8f8f'
                      }`,
                  }}
                >

                  Members
                </span>
              </NavLink>
            </NavItem>
          </Nav>
        </Colxx>
        <Colxx xxs="12" className="mb-1">
          <TabContent activeTab={channel}>
            <Colxx xxs="12" className="mb-3">
              {contactList.length > 0 && (
                <ContactList
                  handleContactLoad={handleContactLoad}
                  propertyId={propertyId}
                  columns={
                    channel !== ''
                      ? contactCompendiumTableColumns
                      : contactTableColumns
                  }
                  data={contactList}
                ></ContactList>
              )}
            </Colxx>
          </TabContent>{' '}
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          <Pagination
            currentPage={currentPage}
            totalPage={TotalPages}
            onChangePage={(i) => onChangePage(i)}
          />{' '}
        </Colxx>
      </Row>
      {addContact && (
        <ContactForm
          toggle={toggle}
          visible={addContact}
          propertyId={propertyId}
          handleSubmit={handleSave}
        ></ContactForm>
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};
export default injectIntl(connect(mapStateToProps, {})(Index));
